import React from 'react'
import Icon from '../assets/iconMdalGift.svg'
import BGModal from '../assets/modalBG.svg'

interface TypeOption {
  image: string
  nbrPoint: number
  montant?: string
  color: string
  type: string
  description: string
}

interface Props {
  typeCarte: TypeOption
  isClosed: (val: boolean) => void
  handleSelected: () => void
}
const SpendGiftModal: React.FC<Props> = ({ typeCarte, isClosed, handleSelected }) => {
  return (
    <div className="fixed flex flex-col justify-center place-items-center inset-0 z-50 isolate bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px]">
      <div className="-mb-[30px] ">
        <img src={Icon} alt="" />
      </div>

      <img className=" relative" src={BGModal} width={327} height={78} alt="" />

      <div className="flex w-[327px] rounded-b-[16px] pb-8 flex-col gap-6 items-center bg-[#FFF] ">
        <h1 className="text-[20px] font-bold text-[#2D2A66]">Êtes-vous sûr ?</h1>
        <p className="text-[#6B7280] text-[16px] text-center w-[250px]">
          Vous allez dépenser <span className="font-bold"> {typeCarte.nbrPoint} RP</span> <br />
          pour bénéficier {typeCarte.description}
        </p>

        <div className=" flex h-[56px] justify-center gap-4 w-full">
          <button
            onClick={() => isClosed(false)}
            className=" border-2 border-[#5754E5] w-[134px] rounded-[16px] text-[#5754E5] font-bold "
          >
            Annuler
          </button>
          <button onClick={handleSelected} className="bg-[#5754E5] w-[134px] rounded-[16px] text-white font-bold ">
            Je confirme !
          </button>
        </div>
      </div>
    </div>
  )
}

export default SpendGiftModal
